import React from 'react';
import { Stack, Text } from '@moda/om';
import { useFeatureFlag, FulfillmentTypes } from '@moda/portal-stanchions';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import { LineItemReturnPolicy } from '../LineItemReturnPolicy';
import { LineItemMiniGranularity } from '../LineItemMini';

import './LineItemShippingDetails.scss';

type Props = {
  granularity?: LineItemMiniGranularity;
  item: LineItem;
};

export const LineItemShippingDetails: React.FC<Props> = ({
  granularity = LineItemMiniGranularity.Full,
  item: {
    attributes: {
      expectedDeliveryTime,
      returnPolicy,
      promotionApplicableMessage,
      returnPolicyCode,
      isAvailableNow,
      fulfilmentType,
      customerDeliveryNotes
    }
  }
}) => {
  // This is a very hacky solution to patch the expected shipping time message with
  // a delay of a number of days specified in the "expected-delivery-delay-days" flag.
  const applyDelay = function (message: string | null | undefined, daysDelay: number) {
    if (message && message.includes('day') && isAvailableNow && daysDelay) {
      return message.replace(/\d+/g, days => String(Number(days) + daysDelay));
    }
    return message;
  };
  const delayDays = useFeatureFlag('expected-delivery-delay-days', [
    { default: 0 },
    { getFromTreatment: treatment => Number(treatment) }
  ]);

  const isDropshipItem =
    fulfilmentType === FulfillmentTypes.DropShip || fulfilmentType === FulfillmentTypes.Fulfillment;

  const expectedDeliveryReworded = expectedDeliveryTime?.replace(/^\w+.*:/, 'Shipping est. ');
  const adjustedExpectedDeliveryTime = applyDelay(expectedDeliveryReworded, delayDays);

  const showExpectedDeliveryTime =
    Boolean(expectedDeliveryTime) && !isAvailableNow && !(isDropshipItem && customerDeliveryNotes);

  return (
    <Stack space={4}>
      {showExpectedDeliveryTime && <Text>{adjustedExpectedDeliveryTime}</Text>}

      {granularity === LineItemMiniGranularity.Full && (
        <LineItemReturnPolicy
          returnPolicy={returnPolicy}
          returnPolicyCode={returnPolicyCode}
          promoCodeApplied={Boolean(promotionApplicableMessage)}
        />
      )}

      {!isAvailableNow && (
        <div>
          RESERVE TODAY
          <div>
            An advance payment of 50% is required at checkout.
            {granularity === LineItemMiniGranularity.Full &&
              ' The remaining balance will be charged when the item ships.'}
          </div>
        </div>
      )}
    </Stack>
  );
};
